export default "__VITE_ASSET__DFG6ju0i__"